export default {"src":"/_next/static/media/ic-twitter.3a60bd45.svg","height":16,"width":16};